import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React from "react";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const dauData = [
    { name: "Mon", users: 600 },
    { name: "Tue", users: 820 },
    { name: "Wed", users: 760 },
    { name: "Thu", users: 900 },
    { name: "Fri", users: 670 },
    { name: "Sat", users: 1020 },
    { name: "Sun", users: 890 },
];

const ViewVendorBlogs = () => {
    const navigate = useNavigate();

    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const blog = {
        id: "#ART-001",
        title: "How to Style Your Winter Jacket",
        cover: "/static/images/placeholder.png",
        category: "Styling Tips",
        excerpt: "Learn how to match winter jackets with everyday outfits.",
        content: "<p>This is rich text content...</p>",
        relatedProducts: ["Winter Jacket", "Leather Boots"],
        status: "Published",
        publishDate: "2025-01-12",
        tags: "winter, styling, jackets",
        seoTitle: "Best Winter Jacket Styling Tips",
        seoDesc: "Learn the top styling tricks for winter jackets.",
        language: "English",
    };

    return (
        <>
            <div className="main_title">
                <h1>View Journal</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button>-<button onClick={() => navigate("/vendor-blogs")}>Vendor Journals</button>-View Journal
                </p>
            </div>
            <div className="cards">
                    <div className="form view_mode">
                        <div className="gap_m">
                            {/* Article Title */}
                            <div className="control_group w_100">
                                <label htmlFor="view-article-title">Article Title</label>
                                <p id="view-article-title" className="view_value">{blog.title}</p>
                            </div>
                            {/* Cover Image */}
                            <div className="control_group w_100 vew_img no_radius">
                                <label htmlFor="view-cover-image">Cover Image</label>
                                <figure id="view-cover-image">
                                    <img
                                        src={blog.cover}
                                        alt="cover"
                                        className="view_image"
                                    />
                                </figure>
                            </div>
                            {/* Category */}
                            <div className="control_group w_50">
                                <label htmlFor="view-category">Category</label>
                                <p id="view-category" className="view_value">{blog.category}</p>
                            </div>
                            {/* Excerpt */}
                            <div className="control_group w_50">
                                <label htmlFor="view-excerpt">Short Summary / Excerpt</label>
                                <p id="view-excerpt" className="view_value">{blog.excerpt}</p>
                            </div>
                            {/* Description */}
                            <div className="control_group w_100">
                                <label htmlFor="view-description">Description</label>
                                <div
                                    id="view-description"
                                    className="view_richtext"
                                    dangerouslySetInnerHTML={{ __html: blog.content }}
                                />
                            </div>
                            {/* Related Products */}
                            <div className="control_group w_100">
                                <label htmlFor="view-related-products">Related Products</label>
                                <p id="view-related-products" className="view_value">
                                    {blog.relatedProducts.join(", ")}
                                </p>
                            </div>
                            {/* Status */}
                            <div className="control_group w_50">
                                <label htmlFor="view-status">Status</label>
                                <p id="view-status" className="view_value">{blog.status}</p>
                            </div>
                            {/* Publish Date */}
                            <div className="control_group w_50">
                                <label htmlFor="view-publish-date">Published On</label>
                                <p id="view-publish-date" className="view_value">{blog.publishDate}</p>
                            </div>
                            {/* Tags */}
                            <div className="control_group w_50">
                                <label htmlFor="view-tags">Tags / Keywords</label>
                                <p id="view-tags" className="view_value">{blog.tags}</p>
                            </div>
                            {/* SEO Title */}
                            <div className="control_group w_50">
                                <label htmlFor="view-seo-title">SEO Title</label>
                                <p id="view-seo-title" className="view_value">{blog.seoTitle}</p>
                            </div>
                            {/* SEO Description */}
                            <div className="control_group w_100">
                                <label htmlFor="view-seo-desc">SEO Description</label>
                                <p id="view-seo-desc" className="view_value">{blog.seoDesc}</p>
                            </div>
                            {/* Language */}
                            <div className="control_group w_50">
                                <label htmlFor="view-language">Language</label>
                                <p id="view-language" className="view_value">{blog.language}</p>
                            </div>
                        </div>
                    </div>
            </div>
        </>
    );
};

export default ViewVendorBlogs;
